<template>
	<div class="b-dropdown__item" @click="handleClick">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "BDropdownItem",
	methods: {
		handleClick() {
			this.$emit("click");
			this.$parent.$emit("item-click");
		},
	},
};
</script>
